import { NotificationHistory } from "@callveriq/type/WebSocketNotification";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react";

const getDomain = (): string => {
    const { hostname } = new URL(window.location.href);
    return hostname.split(".")?.[0] ?? "";
};

export const notificationApiSlice = createApi({
    reducerPath: "notificationApiSlice",
    baseQuery: fetchBaseQuery({
        baseUrl: `https://${
            import.meta.env.VITE_APP_GPT || "gpt.callveriq.com"
        }/${getDomain()}/api/v1`,
    }),
    endpoints: (builder) => ({
        getPrivateHistory: builder.query<
            {
                notifications: NotificationHistory["messages"];
                lastUpdated: number | null;
            },
            void
        >({
            queryFn: () => {
                return {
                    data: {
                        notifications: [],
                        lastUpdated: null,
                    },
                };
            },
        }),
        getGeneralHistory: builder.query<
            {
                notifications: NotificationHistory["messages"];
                lastUpdated: number | null;
            },
            void
        >({
            queryFn: () => {
                return {
                    data: {
                        notifications: [],
                        lastUpdated: null,
                    },
                };
            },
        }),
        generateSummary: builder.mutation<
            void,
            {
                meeting_id?: number | null;
                account_id?: number;
                is_account_summary?: boolean;
                meeting_title: string | null;
                transcript_path?: string | null;
                channel: string;
                account_name?: string | null;
            }
        >({
            query: (payload) => ({
                url: "/summary/",
                method: "POST",
                body: payload,
            }),
        }),
    }),
});

export const { useGetPrivateHistoryQuery, useGenerateSummaryMutation } =
    notificationApiSlice;
